<template>
    <div class="box is-paddingless">
        <div
            v-for="user in usersThatHavePlayed.slice(0, 5)"
            :key="user._id"
            class="level is-mobile lb-session-user-ranking px-5 py-3 is-marginless"
        >
            <div v-if="user.time != '0'" class="level-left">
                <div class="level-item">
                    <user-mini-profile :user="user" :show-school="true" />
                </div>
            </div>
            <div v-if="user.time != '0'" class="level-right">
                <div class="level-item">
                    <div class="has-text-centered">
                        <p
                            class="title is-5 has-text-weight-bold has-text-primary"
                        >{{ user[field] }}</p>
                        <p>{{ units }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserMiniProfile from '@/components/UserMiniProfile';
export default {
    components: {
        UserMiniProfile,
    },
    props: {
        ranking: {
            type: Array,
            default: () => {
                return [];
            },
        },
        units: {
            type: String,
            default: undefined,
        },
        field: {
            type: String,
            default: 'score',
        },
    },
    computed: {
        usersThatHavePlayed() {
            return this.ranking.filter((user) => user.time != '0');
        },
    },
};
</script>

<style scoped>
.lb-session-user-ranking {
    border-bottom: #d8d8d8 1px solid;
}
</style>
